// Scoring — mode-agnostic scoreboard interfaces
// Each game mode provides a ScoreboardConfig that defines columns, event processing, and sorting.
// Lives on main thread only (contains functions that can't cross worker boundary).

export interface ScoreboardColumn {
  key: string;
  label: string;
  format(value: number): string;
  sortDirection: "asc" | "desc";
}

export interface ScoreboardConfig {
  columns: ScoreboardColumn[];
  /** Called for every sim event (all players). Accumulate scoring state here. */
  processEvent(playerId: number, type: number, d0: number, d1: number): void;
  /** Primary sort value for ranking. Lower is better for "asc", higher for "desc". */
  sortValue(playerId: number): number;
  /** Get a column value for display. */
  columnValue(playerId: number, key: string): number;
  /** Whether this player has completed a scoring action (finished a run, got a kill, etc.) */
  hasScore(playerId: number): boolean;
}

/** Format simulation ticks as MM:SS.mmm */
export function formatTicks(ticks: number): string {
  const totalMs = Math.round(ticks * (1000 / 60));
  const min = Math.floor(totalMs / 60000);
  const sec = Math.floor((totalMs % 60000) / 1000);
  const ms = totalMs % 1000;
  return `${min}:${String(sec).padStart(2, "0")}.${String(ms).padStart(3, "0")}`;
}
